import { LitElement } from 'lit-element'
import { register } from '@polleverywhere/hmr-custom-element'
import './spacer.scss'

/**
 * Flex spacer is used as a divider between navigation items to create space
 * between them.
 *
 * @element pe-navigation-spacer
 */
export default class Spacer extends LitElement {
  static get tagName () { return 'pe-navigation-spacer' }

  createRenderRoot () { return this }
}

register(module, Spacer.tagName, Spacer)
